import _ from 'lodash'
import {
  buildUrl
} from '@/util'

let defaultPreference = {
  type: 'preference',
  name: '',
  data: {
    amount: [0, 0],
    field: [],
    stage: []
  }
}

let defaultCase = {
  type: 'case',
  name: '',
  data: []
}

export default {
  namespaced: true,
  /**
   * @see http://dartcome.nutsb.com/api/graphql
   * @see https://doc.nutsb.com/#/dartcome/pr-server-node/graphql/type?id=usertype
   */
  state: {
    account: '',
    /** @see https://doc.nutsb.com/#/dartcome/pr-server-node/graphql/type?id=cardtype */
    card: {
      _id: '',
      email: '',
      head_image_url: '', // 头像
      name: '',
      phone: '',
      profile: '', // 个人简介
      title: '' // 头衔
    },
    city: '',
    /** @see https://doc.nutsb.com/#/dartcome/pr-server-node/graphql/type?id=homepagetype */
    homepage: {
      auto_open: 0, // 0 = 不自动打开, 1 = 自动打开
      url: '' // 用户网站网址
    },
    /** @see https://doc.nutsb.com/#/dartcome/pr-server-node/graphql/type?id=investortype */
    investor: {
      deliverAnswerRate: 0,
      deliverCount: 0,
      deliverFinish: 0,
      deliverIncome: 0,
      deliverPrice: 0, // 投递价格，单位：分
      baseCount: 0, // 基础计数。 (而外添加的投递数量)
      id: '', // investor id
      state: 0 // 状态：0-正常；1-不可投递
    },
    province: '',
    pr_state: 1, // PR状态(关闭 = 0, 开启 = 1, 申请中 = 2, 审核中 = 3, 审核失败 = 4, 重新申请中 = 5)
    pv: 0, // 浏览数
    /** @see https://doc.nutsb.com/#/dartcome/pr-server-node/graphql/query?id=usermodule */
    user_module: [],
    uuid: ''
  },
  mutations: {
    SET_USER (state, data) {
      Object.keys(data).map(key => {
        if (key === 'user_module') {
          // NOTE: User module 可支持重复资料类型，但是只有 array 的第 1 个(preference) 及 第 1 个(case) 是正确的
          const preference = _.find(data.user_module, ({ type }) => type === 'preference')
          const cases = _.find(data.user_module, ({ type }) => type === 'case')
          state.user_module = [
            _.assign(defaultPreference, preference),
            _.assign(defaultCase, cases)
          ]
        } else if (typeof data[key] === 'object') {
          _.assign(state[key], data[key])
        } else {
          state[key] = data[key]
        }
      })

      return state
    },
    SET_USER_PUBLIC_INFO (state, {card, city, province}) {
      _.assign(state.card, card)
      state.city = city
      state.province = province
      return state
    },
    SET_USER_HEAD_IMG (state, { card }) {
      state.card.head_image_url = card.head_image_url
      return state
    },
    UPSERT_USER_MODULE (state, data) {
      let target = state.user_module.find(item => item.id === data.id)
      if (!target) target = state.user_module.find(({ type }) => type === data.type)
      if (target) {
        _.assign(target, data)
      } else {
        state.user_module.push(target)
      }
      return state
    }
  },
  getters: {
    user: state => state,
    modules: (state, getters, rootState) => {
      const modules = state.user_module.map(item => {
        let params = {}
        const { id, data } = item
        switch (item.type) {
          case 'preference':
            const stage = ['种子', '天使轮', 'Pre-A', 'A轮', 'B轮', 'C轮', 'D轮', 'Pre-IPO', 'IPO']
            const stageValue = _.intersection(stage, data.stage || [])
            const { industries } = rootState.api.conf

            params = {
              id,
              type: 'md-list',
              name: '投资偏好',
              value: [
                {
                  type: 'tag',
                  name: '投资阶段',
                  ref: 'stage',
                  value: stageValue
                },
                {
                  type: 'tag',
                  name: '投资领域',
                  ref: 'industry',
                  value: _.sortBy(
                    (data.field || []),
                    field => _.findIndex(industries, { value: field })
                  )
                },
                {
                  type: 'range',
                  name: '单个项目投资金额',
                  unit: 10000,
                  value: data.amount || []
                }
              ]
            }
            break
          case 'case':
            params = {
              id,
              type: 'md-case',
              name: '机构投资案例',
              value: data.map(row => {
                return {
                  type: 'media',
                  name: row.name || '',
                  value: row.desc || '',
                  label: _.get(row, 'industry'),
                  logo: _.get(row, 'logo'),
                  img: _.get(row, 'logo.url')
                }
              })
            }
            break
        }
        return params
      })

      return modules
    }
  },
  actions: {
    /**************************************************
     * v2 graphql api
     **************************************************/
    async r ({dispatch, rootState, rootGetters}, options) {
      let key = 'dcV2Graphql'
      options.url = buildUrl(rootGetters.rootDomain, key)
      options.method = 'post'

      let authFailReLaunch = false
      if (options.hasOwnProperty('authFailReLaunch')) {
        authFailReLaunch = options.authFailReLaunch
        delete options.authFailReLaunch
      }

      let res = await dispatch('api/r', options, {root: true})
      let errors = _.get(res, 'data.errors')

      if (res.status < 400 && !errors) {
        return _.get(res, 'data.data')
      }

      let firstErrorCode = _.get(errors, '[0].code')
      let code = firstErrorCode
      if (authFailReLaunch && code === 401 && _.get(res, 'data.extensions.key') === 'token') {
        await dispatch('me/logout', null, {root: true})
        window.reload()
        throw new Error(`登入授权失效，请重新登入`)
      }

      let firstErrorMsg = _.get(errors, '[0].msg')
      let msg = firstErrorMsg
      let moreInfo = [key, res.status, code]

      if (msg) {
        let firstResKey = _.get(errors, '[0].extensions.key')
        moreInfo.push(firstResKey)
        switch (firstResKey) {
          case 'email': {
            msg = '修改格式不正确，请重新填写。'
            break
          }
          default:
            if (firstErrorMsg === 'ARGUMENT_INVALID') {
              msg = '修改格式不正确，请重新填写。'
            }
        }
      } else {
        msg = `请求失败。`
      }
      if (rootState.env === 'prod') {
        msg = `${msg}${moreInfo.join(', ')}`
      }
      // TODO: 暂时统一让后端吐
      msg = _.get(errors, '[0].msg')
      throw new Error(msg)
    },
    /**************************************************
     * auth
     **************************************************/
    async getToken ({dispatch}) {
      let data = await dispatch('r', {
        data: {
          query: `{getToken}`
        }
      })
      return data.getToken
    },
    // https://github.com/nutspie/doc/blob/master/dartcome/pr-server-node/graphql/query.md
    async weixinJsApiToken ({dispatch}, {url}) {
      let query = `query ($appId: String, $url: String) {
        weixinJsApiToken(appId: $appId, url: $url) { appId, nonceStr, signature, timestamp }
      }`
      let data = await dispatch('r', {
        data: {
          query,
          variables: {
            appId: 'wx778a481d4e07a603',
            url
          }
        }
      })
      return data.weixinJsApiToken
    },
    /**************************************************
     * share data
     **************************************************/
    async chinaProvinceCityData ({dispatch}) {
      let data = await dispatch('r', {
        data: {
          query: `{chinaProvinceCityData}`
        }
      })
      return data.chinaProvinceCityData
    },
    async fetchProvinceCity ({dispatch}) {
      let data = await dispatch('chinaProvinceCityData')
      let dataFixed = data.map((row, i) => {
        return {
          index: i,
          value: row.provinceName,
          label: row.provinceName,
          children: row.cityInfoList.map((row, i) => {
            return {
              index: i,
              label: row.name,
              value: row.name
            }
          })
        }
      })
      return dataFixed
    },
    /**************************************************
     * user data
     **************************************************/
    async gp ({dispatch}, {id = [], type = 0} = {}) {
      let gpBoxQuery = `{ unread_count name p (pagination: {limit: 0 }) { _id } }`
      let query = `query {
        gp {
          system0 ${gpBoxQuery}
          system3 ${gpBoxQuery}
          system4 ${gpBoxQuery}
        }
      }`
      let data = await dispatch('r', {
        data: {query}
      })
      return data.gp
    },
    async p ({dispatch}, {ids = [], type = 0}) {
      let query
      switch (type) {
        // partial
        case 1: {
          query = `query ($pagination: paginationInput, $filter: JSON) {
            p (pagination: $pagination, filter: $filter) {
              _id, deliver_id, created_at, name, question, is_seen
            }
          }`
          break
        }
        // full
        case 0:
        default:
          query = `query ($filter: JSON) {
            p (filter: $filter) {
              _id, deliver_id, created_at, is_seen,
              name, question, amount, desc,
              contact_name, contact_phone, contact_weixin, contact_email,
              att { _id, name, extname, filesize, url, created_at }
              url { name, url }
            }
          }`
      }
      let data = await dispatch('r', {
        data: {
          query,
          variables: {
            filter: {
              _id: {
                $in: ids
              }
            },
            pagination: {
              limit: ids.length
            }
          }
        }
      })
      return data.p
    },
    async me ({dispatch}, {headers = {}} = {}) {
      let pQuery = `{
        _id
        gp_moved_at
        gp_source_label
      }`
      let gpBoxQuery = `{
        action name onworkplace order
        p ${pQuery}
      }`
      let gpQuery = `{
        system0 ${gpBoxQuery}
        system1 ${gpBoxQuery}
        system2 ${gpBoxQuery}
        system3 ${gpBoxQuery}
        system4 ${gpBoxQuery}
        extra ${gpBoxQuery}
      }`
      let cardQuery = `{
        name, head_image_url, email, phone, profile, title
      }`
      let investorQuery = `{
        deliverPrice,
        deliverCount,
        deliverIncome,
        deliverAnswerRate,
        deliverFinish,
        baseCount,
        state
      }`
      let moduleQuery = `{ id, name, type, data }`
      let meQuery = `{
        _id uuid phone account
        pr_state pv
        gp ${gpQuery}
        card ${cardQuery}
        investor ${investorQuery}
        user_module ${moduleQuery}
      }`
      let options = {
        data: {
          query: `query { me ${meQuery} }`
        },
        headers
      }
      let data = await dispatch('r', options)

      return data.me
    },
    /**
     * get me data and format the data as v1 me data
     */
    async v1Me ({dispatch}, {headers = {}} = {}) {
      let me = await dispatch('me', {headers})
      me._type = 'u'
      me.card.default_avatar = 1
      let gp = me.gp
      let fixedGp = {}
      for (let key of Object.keys(gp)) {
        if (key.substr(0, 6) === 'system') {
          let order = gp[key].order
          fixedGp[order] = gp[key]
          fixedGp[order].p = gp[key].p.map(row => {
            row._type = 'p'
            return row
          })
        } else {
          fixedGp[key] = gp[key]
        }
      }
      me.gp = fixedGp
      return me
    },
    /**
     * TODO: Patch pr user data / Get user data
     * Patch pr user data
     * @param {object<action>} action - vuex action
     * @param {object<userType>} params - user type data with `type`
     * `type`: 0 => Get whole userType data, 1 => Get card information only
     */
    async user ({dispatch, commit}, params) {
      const { uuid, account, type } = params
      const vKey = (uuid) ? 'uuid' : 'account'
      let query
      switch (type) {
        case 1:
          query = `query ($v: [String]) {
            user (${vKey}: $account) {
              card { name, email, title, head_image_url },
            }
          }`
          break
        // The query should be same as dartcome-pr-server-node src/router/html/index.js L179
        case 0:
        default:
          query = `query ($v: [String]) {
            user (${vKey}: $v) {
              uuid, account,
              province, city,
              pr_state, pv,
              card { _id, name, phone, email, title, profile, head_image_url },
              investor {
                baseCount,
                deliverPrice,
                deliverCount,
                deliverIncome,
                deliverAnswerRate,
                deliverFinish,
                id,
                state
              },
              user_module { id, name, type, data },
              homepage { auto_open, url }
            }
          }`
      }

      let data = await dispatch('r', {
        data: {
          query,
          variables: {
            v: uuid || account
          }
        }
      })

      if (data.user && type !== 1) commit('SET_USER', _.get(data, 'user[0]'))
      return _.get(data, 'user[0]')
    },
    /**
     * Set user data from ssr
     * @param {object<store>} store  The store object
     * @param {*} data
     */
    setUser ({ commit }, data) {
      commit('SET_USER', data)
      return data
    },
    /**************************************************
     * modify
     **************************************************/
    /**
     * Update user's information
     * @param {object<store>} store Store api
     * @param {object} params Parameters is used to update user's information
     * @param {string} params.name     The user's name
     * @param {string} params.title    The user's title
     * @param {string} params.province The user's province
     * @param {string} params.city     The user's city
     */
    async updateUser ({dispatch, commit}, params) {
      let keys = Object.keys(params)
      let query = `
        mutation (${keys.map(k => `$${k}: String`).join(' ')}) {
          updateUser(${keys.map(k => `${k}: $${k}`).join(' ')}) {
            id,
            card { name, title, profile }
            city,
            province,
          }
        }
      `
      let data = await dispatch('r', {
        data: {
          query,
          variables: params
        },
        loading: '保存中...'
      })
      commit('SET_USER_PUBLIC_INFO', data.updateUser)
      return data.updateUser
    },
    async updateUserHeadImage ({dispatch, commit, ...els}, { file }) {
      try {
        await dispatch('checkFile', { file }, { root: true })
        const formdata = new FormData()
        formdata.append('file', file)
        const query = `
          mutation {
            updateUserHeadImage { id, card { head_image_url } }
          }
        `
        formdata.append('query', query)
        const data = await dispatch('r', {
          data: formdata,
          loading: '保存中...'
        })

        commit('SET_USER_HEAD_IMG', data.updateUserHeadImage)
        return data.updateUserHeadImage
      } catch (err) {
        console.error(err)
      }
    },
    async updateUserModule ({ dispatch, commit }, {id, type, input}) {
      let updateType = ''
      let data = {}
      switch (type) {
        case 'md-list':
          updateType = 'preference'
          data = {
            stage: _.get(input, '[0].value', []),
            field: _.get(input, '[1].value', []),
            amount: _.get(input, '[2].value', [0, 0])
          }
          break
        case 'md-case':
          updateType = 'case'
          data = input.map(row => {
            return {
              name: row.name,
              desc: row.value,
              industry: row.label,
              logo: row.logo
            }
          })
          break
      }
      if (updateType === '') return 'Error type'

      let result = null
      if (id) {
        result = await dispatch('r', {
          data: {
            query: `
              mutation ($id: Int, $type: String, $data: JSON) {
                updateUserModule(id: $id, type: $type, data: $data) { id, name, type, data }
              }
            `,
            variables: {
              id,
              type: updateType,
              data
            }
          }
        })
        commit('UPSERT_USER_MODULE', result.updateUserModule)
        return result.updateUserModule
      } else {
        return dispatch('createUserModule', { updateType, data })
      }
    },
    async createUserModule ({ dispatch, commit }, { updateType, data }) {
      let result = await dispatch('r', {
        data: {
          query: `mutation ($type: String, $data: JSON) {
            createUserModule(type: $type, data: $data) { id, name, type, data }
          }`,
          variables: {
            type: updateType,
            data
          }
        }
      })
      commit('UPSERT_USER_MODULE', result.createUserModule)
      return result.createUserModule
    },
    async createUserImage ({dispatch}, {file}) {
      let formdata = new FormData()
      formdata.append('file', file)
      let query = `mutation { createUserImage { id, url, width, height } }`
      formdata.append('query', query)
      let data = await dispatch('r', {
        data: formdata
      })
      return data.createUserImage
    },
    async sendNutsbpToDartcome ({dispatch}, variables) {
      let data = await dispatch('r', {
        data: {
          query: `mutation ($deliverId: String) {
            sendNutsbpToDartcome (deliverId: $deliverId)
          }`,
          variables
        }
      })
      return data.sendNutsbpToDartcome
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/api/dartcome/index.js